// src/lib/onboarding/email-gate.ts

export interface EmailGateInput {
  /** A real Supabase user is signed in (not just a persisted role). */
  hasUser: boolean;
  /** Mock/demo-bypass mode — there is no real Supabase session or email to confirm. */
  isMockMode: boolean;
  /**
   * `authUser?.email_confirmed_at != null`. CRITICAL SAFETY: when remote email
   * confirmation is OFF (current project state) Supabase populates
   * `email_confirmed_at` immediately at signup, so this is `true` for every
   * existing/confirmed session and the gate is naturally inert. Only a
   * genuinely-null `email_confirmed_at` (→ `false`) can gate a user.
   */
  emailConfirmed: boolean;
}

/**
 * Access gate (onboarding redesign D2 / proposal §7): should a signed-in user be
 * routed to the confirm-email screen BEFORE any onboarding/app/admin route?
 *
 * Used by the `index.tsx` redirect guard. Returns `true` ONLY for a real,
 * signed-in user whose email is genuinely unconfirmed. It must never lock out:
 * - confirmed users (`emailConfirmed=true`) — the inert case when confirmation is off,
 * - mock/demo sessions (no real email),
 * - unauthenticated visitors (landing page).
 */
export function shouldGateEmailConfirmation({
  hasUser,
  isMockMode,
  emailConfirmed,
}: EmailGateInput): boolean {
  if (isMockMode) return false;
  if (!hasUser) return false;
  return !emailConfirmed;
}
